<template>
    <div class="main-content">
      <!-- Page Header Start -->
      <PageHeader>
        <PageHeaderTitleContent>
          <TitleTextContent
            :titleText="policy?.policyName"
          />
          <router-link 
            :to="{
              name: 'policy-corner',
            }"
          >
            <v-btn
              rounded
              large
              dark
              :color="'#424EC4'"
            >
              Back to Policy Corner
            </v-btn>
          </router-link>
        </PageHeaderTitleContent>
      </PageHeader>
      <!-- Page Header End -->

      <section class="section p-0 mt-5 mb-5 section-content">
        <div class="container px-3 px-md-0 px-lg-0 px-lg-0">
            <div class="row m-0">
                <div class="col-12 p-0 d-flex justify-content-start">
                    <div class="text-policy pt-1 mb-4 mr-3">
                        Visit Website:
                    </div>
                    <v-btn
                        rounded
                        large
                        dark
                        :color="'#424EC4'"
                        width="200"
                        @click="() => openPolicyWebsite(policy?.policyWebsiteUrl)"
                    >
                        Go to Policy
                    </v-btn>
                </div>
            </div>

            <div class="row m-0 mt-3 mb-5">
                <div class="col-12 p-0 text-policy">
                    Policy Overview
                </div>
            </div>

            <div class="w-100 h-auto" v-html="policy?.policyInfoContent">
            </div>
        </div>
      </section>
    </div>
</template>

<script>
    import PageHeader from "./library/widgets/page-header.vue";
    import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
    import TitleTextContent from './library/widgets/title-text-content.vue';
    import policyCornerInfoData from '../utils/policyCornerData';

    export default {
        name: 'policyInfo',
        components: {
            PageHeader,
            PageHeaderTitleContent,
            TitleTextContent,
        },
        props: {
            policyCode: String,
        },
        data(){
            return {
                policy: null,
                staticPolicies: policyCornerInfoData,
            };
        },
        mounted() {
            this.policy = this.staticPolicies.find((policy) => policy.policyCode === this.policyCode);
        },
        methods: {
            openPolicyWebsite(policyWebsiteUrl) {
                window.open(policyWebsiteUrl, '_blank');
            },
        },
    }
</script>

<style scoped>
    .text-policy {
        color: #272727;
        font-family: GeomGraphic;
        font-size: clamp(22px, 4vw, 30px);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: left;
    }

    ::v-deep .header-size {
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    ::v-deep .header-bold-text {
        font-size: clamp(18px, 2vw, 28px);
        font-weight: bold;
    }

    ::v-deep .header-italized-text {
        font-size: clamp(18px, 2vw, 28px);
        font-style: italic;
    }

    ::v-deep .text-content {
        font-size: clamp(16px, 2vw, 24px);
        font-style: normal;
    }
</style>